/* Stealth V2 rider reviews (sections/sp-reviews.liquid). Everything is server rendered; this only filters, sorts,
   expands, marks the sound profile picked in the buy box, and publishes two analytics events.
   Events (for a Customer Events pixel to forward to GA4): sp_reviews_viewed {product_id} once in view,
   sp_reviews_interaction {product_id, action} on star jump, filter, sort, show all. */
(function () {
  'use strict';
  var publish = function (name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
  };

  function init(root) {
    if (root.__spReviews) return;
    root.__spReviews = true;
    var pid = root.getAttribute('data-product-id');
    var list = root.querySelector('[data-sp-list]');
    var items = list ? Array.prototype.slice.call(list.querySelectorAll('[data-sp-review]')) : [];
    var more = root.querySelector('[data-sp-more]');
    var none = root.querySelector('[data-sp-none]');
    var sortSel = root.querySelector('[data-sp-sort]');
    var filterBtns = Array.prototype.slice.call(root.querySelectorAll('[data-sp-filter]'));
    var mq = window.matchMedia('(max-width: 768px)');
    var state = { type: 'all', value: '', sort: 'recent', expanded: false };

    var limit = function () {
      return parseInt(root.getAttribute(mq.matches ? 'data-phone-n' : 'data-desk-n'), 10) || 3;
    };
    var num = function (el, a) { return parseInt(el.getAttribute(a), 10) || 0; };

    function apply() {
      if (!list) return;
      var match = items.filter(function (el) {
        if (state.type === 'all') return true;
        if (state.type === 'rating') return el.getAttribute('data-rating') === state.value;
        if (state.type === 'profile') return el.getAttribute('data-profile') === state.value;
        if (state.type === 'finish') return el.getAttribute('data-finish') === state.value;
        return true;
      });
      var sorted = match.slice().sort(function (a, b) {
        if (state.sort === 'high' && num(b, 'data-rating') !== num(a, 'data-rating')) return num(b, 'data-rating') - num(a, 'data-rating');
        if (state.sort === 'low' && num(a, 'data-rating') !== num(b, 'data-rating')) return num(a, 'data-rating') - num(b, 'data-rating');
        if (num(b, 'data-photos') > 0 !== num(a, 'data-photos') > 0) return num(b, 'data-photos') > 0 ? 1 : -1;
        if (num(b, 'data-date') !== num(a, 'data-date')) return num(b, 'data-date') - num(a, 'data-date');
        return num(a, 'data-index') - num(b, 'data-index');
      });
      items.forEach(function (el) { el.hidden = true; });
      var n = limit();
      sorted.forEach(function (el, i) {
        list.appendChild(el);
        el.hidden = !state.expanded && i >= n;
      });
      if (none) none.hidden = sorted.length > 0;
      if (more) {
        var rest = sorted.length > n && !state.expanded;
        more.parentNode.hidden = !rest;
        more.setAttribute('aria-expanded', state.expanded ? 'true' : 'false');
        var word = sorted.length === 1 ? ' written review' : ' written reviews';
        more.textContent = 'Show all ' + sorted.length + word;
      }
    }

    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var type = btn.getAttribute('data-sp-filter');
        var value = btn.getAttribute('data-value') || '';
        var same = state.type === type && state.value === value;
        state.type = same || type === 'all' ? 'all' : type;
        state.value = same || type === 'all' ? '' : value;
        filterBtns.forEach(function (b) {
          var on = (b.getAttribute('data-sp-filter') === state.type && (b.getAttribute('data-value') || '') === state.value);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
          b.classList.toggle('is-on', on);
        });
        apply();
        publish('sp_reviews_interaction', { product_id: pid, action: 'filter_' + state.type + (state.value ? '_' + state.value : '') });
      });
    });
    if (sortSel) sortSel.addEventListener('change', function () {
      state.sort = sortSel.value;
      apply();
      publish('sp_reviews_interaction', { product_id: pid, action: 'sort_' + state.sort });
    });
    if (more) more.addEventListener('click', function () {
      state.expanded = true;
      apply();
      publish('sp_reviews_interaction', { product_id: pid, action: 'show_all' });
    });
    if (mq.addEventListener) mq.addEventListener('change', apply);
    apply();

    /* "Your pick": mark the profile of the muffler selected in the buy box. */
    var picks = Array.prototype.slice.call(root.querySelectorAll('.sp-reviews__prof'));
    var markPick = function () {
      if (!picks.length) return;
      var chosen = '';
      var inputs = document.querySelectorAll('[data-variant-input]:checked, select[data-variant-input]');
      Array.prototype.forEach.call(inputs, function (inp) {
        var v = (inp.value || '').toLowerCase();
        if (/balanced/.test(v)) chosen = 'Balanced';
        else if (/aggressive/.test(v)) chosen = 'Aggressive';
        else if (/extreme/.test(v)) chosen = 'Extreme';
      });
      picks.forEach(function (b) {
        var tag = b.querySelector('[data-sp-pick]');
        if (tag) tag.hidden = b.getAttribute('data-value') !== chosen;
      });
    };
    markPick();
    document.addEventListener('change', function (e) { if (e.target.matches && e.target.matches('[data-variant-input]')) setTimeout(markPick, 0); });

    /* Analytics */
    if ('IntersectionObserver' in window) {
      var seen = false;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting && !seen) { seen = true; publish('sp_reviews_viewed', { product_id: pid }); io.disconnect(); }
        });
      }, { threshold: 0.2 });
      io.observe(root);
    }
    Array.prototype.forEach.call(document.querySelectorAll('[data-sp-reviews-jump]'), function (a) {
      a.addEventListener('click', function () { publish('sp_reviews_interaction', { product_id: pid, action: 'star_jump' }); });
    });
  }

  var boot = function () { Array.prototype.forEach.call(document.querySelectorAll('[data-section-type="sp-reviews"]'), init); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
